import Canvas from "./Canvas";
import GameControls from "./GameControls";

const App = () => {
  return (
    <>
      <GameControls />
      <Canvas />
    </>
  );
};

export default App;
